export default __webpack_public_path__ + "static/arcanum_turntable-1969743a581ea834e28796922c16cbca.mp4";